import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import useFetch from "../api/useFetch";
import Table from "./Table";
import Loading from "./Loading";
import { Link, useNavigate } from 'react-router-dom';
import funcs from '../utils/utils';
import usePost from '../api/usePost';
import { useCallback } from 'react';
import EventForm from './EventForm';
import React from 'react';


const Appointment = ({ notify }) => {
  const { postData } = usePost();
  const navigate = useNavigate();
  const [refresh, setRefresh] = useState(false);
    const [eventFormVisible, setEventFormVisible] = useState(false);
  const { id } = useParams();
  const { result: appointment, isLoading: appointmentLoading, error: appointmentError } = useFetch(`/appointment/${id}`, [refresh]);
  const [additionalNote, setAdditionalNote] = useState(null);
  const [servicesTableContent, setServicesTableContent] = useState(null);
  const [transactionsTableContent, setTransactionsTableContent] = useState(null);
  const [possibleTransactionsTableContent, setPossibleTransactionsTableContent] = useState(null);
  const [showAdditionalPayments, setShowAdditionalPayments] = useState(false);

  const match_transaction = useCallback(async (transaction_id) => {
    const data = { appointment_id: appointment.data.id, transaction_id: transaction_id };
    const response = await postData('/match_transaction', data);
  
    if (response) {
      notify(response.message);
      setRefresh((prev) => !prev);
    }
  }, [appointment, postData, notify]);

  const unmatch_transaction = useCallback(async (transaction_id) => {
    const data = { appointment_id: appointment.data.id, transaction_id: transaction_id };
    const response = await postData('/unmatch_transaction', data);
  
    if (response) {
      notify(response.message);
      setRefresh((prev) => !prev); 
    }
  }, [appointment, postData, notify]);

  const attribute_difference = useCallback(async () => {
    const data = { appointment_id: appointment.data.id };
    const response = await postData('/attribute_difference', data);
  
    if (response) {
      notify(response.message);
      setRefresh((prev) => !prev); 
    }
  }, [appointment, postData, notify]);

  const cancel_appointment = useCallback(async () => {
    const data = { appointment_id: appointment.data.id };
    const response = await postData('/cancel_appointment', data);
    if (response) {
      notify(response.message);
      setRefresh((prev) => !prev); 
      navigate("/appointments");
    }
  }, [appointment, postData, notify, navigate]);

  const update_appointment = useCallback(async () => {
    const data = { appointment_id: appointment.data.id, additional_note: additionalNote };
    const response = await postData('/update_appointment', data);
    if (response) {
      notify(response.message);
    }
  }, [appointment, postData, notify, additionalNote]);

  const servicesTableHeader = [
    { content: "Service", size: "md", isLink: false },
    { content: "Cost", size: "sm", isLink: false },
    { content: "Technician Payout", size: "sm", isLink: false },
  ];

  const transactionsTableHeader = [
    { content: "Date", size: 'sm', isLink: false},
    { content: "Client", size: "md", isLink: true, link: '/client' },
    { content: "Amount", size: "sm", isLink: false },
    { content: "Tip", size: "sm", isLink: false },
    { content: "Remove", size: "sm", isLink: false }
  ];

  const possibleTransactionsTableHeader = [
    { content: "Date", size: 'sm', isLink: false},
    { content: "Client", size: "md", isLink: true, link: '/client' },
    { content: "Amount", size: "sm", isLink: false },
    { content: "Tip", size: "sm", isLink: false },
    { content: "Add", size: "sm", isLink: false }
  ];

  useEffect(() => {
    if (appointment && appointment.data && appointment.data.services) {
      setServicesTableContent(
        appointment.data.services.map((item) => [
          item.service_name,
          `$${item.service_cost}`,
          `$${item.split_amount}`,
        ])
      );
      setAdditionalNote(appointment.data.additional_note);
    }
  }, [appointment]);

  useEffect(() => {
    if (appointment && appointment.data && appointment.data.transactions) {
      setTransactionsTableContent(
        appointment.data.transactions.map((item) => [
          funcs.displayDate(item.date_time),
          item.client && [item.client.person && `${item.client.person.first_name ? item.client.person.first_name : '' } ${item.client.person.last_name ? item.client.person.last_name : '' }`, item.client.id],
          `$${item.amount}`,
          item.tip ? `$${item.tip}` : '$0',
          <i onClick={() => unmatch_transaction(item.id)} className="fas fa-trash-alt"></i>,
        ])
      );
      
      setPossibleTransactionsTableContent(
        appointment.possible_transactions
            .sort((a, b) => new Date(b.date_time) - new Date(a.date_time)) // Sort by date_time descending
            .map((item) => [
                funcs.displayDate(item.date_time),
                item.client && [
                    item.client.person && 
                    `${item.client.person.first_name ? item.client.person.first_name : ''} ${item.client.person.last_name ? item.client.person.last_name : ''}`,
                    item.client.id
                ],
                `$${item.amount}`,
                item.tip ? `$${item.tip}` : '$0',
                <i onClick={() => match_transaction(item.id)} className="fas fa-plus"></i>,
            ])
    );    
    }
  }, [appointment, unmatch_transaction, match_transaction]);

  

  return (
    <div className="list">
      <div className="title">APPOINTMENT</div>

      {appointment && (
        <center>
          <div>
            <b>Date</b><br /> {funcs.displayDate(appointment.data.date_time)}
          </div>
          <br />
          <div>
            <b>Time</b><br /> {funcs.displayTime(appointment.data.date_time)}
          </div>
          <br />
          <div>
            <b>Client</b><br />
            {appointment.data.client?.person && (
              <Link to={`/client/${appointment.data.client.id}`}>
                {appointment.data.client.person.first_name} {appointment.data.client.person.last_name}
              </Link>
            )}
          </div>

          {!appointment.data.is_event && (
            <>
              <br />
              <div>
                <b>Technician</b><br />
              {appointment.data.technician?.person && (
              <Link to={`/technician/${appointment.data.technician.id}`}>
                {appointment.data.technician.person.first_name} {appointment.data.technician.person.last_name}
              </Link>
                )}
              </div>
            </>
          )}
          {appointment.data.is_event && (
            <>
              <br />
              <div>
                <b>Technician(s)</b><br />
                {appointment.event_technicians.map((item) => (
                  <React.Fragment key={item.technician.id}>
                    <Link to={`/technician/${item.technician.id}`}>
                      {item.technician.person.first_name} {item.technician.person.last_name}
                    </Link> | {item.payout ? `$${item.payout}` : '$0'}
                  </React.Fragment>
                ))}
              </div>
            </>
          )}
          {appointment.data.is_event && eventFormVisible && (
            <>
              <EventForm appointment_id={appointment.data.id} notify={notify} />
              <br />
              <br />
            </>
          )}
          {appointment.data.is_event && !eventFormVisible && (
            <>
              <br />
              <span className="button" onClick={() => setEventFormVisible(true)}>Add Technician</span>
              <br />
              <br />
            </>
          )}
          <br />
          <div>
            <b>Address</b><br />
            {appointment.data && (
              `${appointment.data.address} ${appointment.data.city} ${appointment.data.state} ${appointment.data.zip_code}`
            )}
          </div>
          <br />
          <b>Technician Payout | Technician Tip</b><br />
          {appointment.data.technician_payout ? `$${parseFloat(appointment.data.technician_payout).toFixed(2)}` : ''} | {appointment.data.technician_tip ? `$${parseFloat(appointment.data.technician_tip).toFixed(2)}` : ''}
          <br />
          <br />

          <b>Additional Note</b><br />
          <textarea cols="50" rows="5" value={additionalNote} onChange={(e) => setAdditionalNote(e.target.value)} />
          <br />
          <button className="button" onClick={() => update_appointment()}>{appointment && appointment.data.additional_note && appointment.data.additional_note !== "" ? 'Update Note' : 'Save Note'}</button>
          <br />
          <br />
          <br />
          {!appointment.data.is_event && (
            <>
              <b>Services</b><br /><br />
              <Table tableHeader={servicesTableHeader} tableContent={servicesTableContent} />
              <br /><br /><br />
            </>
          )}
          
          {appointment.data.transactions?.length > 0 && (
            <>
              <b>Payments</b><br /><br />
              <Table tableHeader={transactionsTableHeader} tableContent={transactionsTableContent} />
            </>
          )}

          <br /><br /><br />
          {!showAdditionalPayments && appointment.data.transactions?.length > 0 && parseFloat(appointment.data.total_payment) > parseFloat(appointment.data.expected_revenue) && (
            <span className="button" onClick={() => attribute_difference()}>Attribute Difference to Tip</span>
          )}
          {!showAdditionalPayments && appointment.data.transactions?.length > 0 && parseFloat(appointment.data.total_payment) < parseFloat(appointment.data.expected_revenue) && (
            <span className="button" onClick={() => attribute_difference()}>Attribute Difference to Discount</span>
          )}
          {!showAdditionalPayments && (
            <span className="button" onClick={() => setShowAdditionalPayments(true)}>Add Payment</span>
          )}
          {appointment.data && (
            <span style={{backgroundColor: 'lightcoral'}} className="button" onClick={() => cancel_appointment()}>Cancel Appointment</span>
          )}
          {showAdditionalPayments && (
            <>
              <b>Select Payment</b><br /><br />
              <Table tableHeader={possibleTransactionsTableHeader} tableContent={possibleTransactionsTableContent} />
            </>
          )}
          <br />
          <br />
          {appointment.review && (
            <>
            <b>Technician Review</b><br /><br />
              {appointment.review.additional_services && (
                <>
                  <b>Additional Services Requested</b><br /> {appointment.review.additional_services}<br /><br />
                </>
              )}
              {appointment.review.client_health && (
                <>
                  <b>Client Health</b><br /> {appointment.review.client_health}<br /><br />
                </>
              )}
              {appointment.review.client_interest && (
                <>
                  <b>Client Interest</b><br /> {appointment.review.client_interest}<br /><br />
                </>
              )}
              {appointment.review.client_satisfaction && (
                <>
                  <b>Client Satisfaction</b><br /> {appointment.review.client_satisfaction}<br /><br />
                </>
              )}
              {appointment.review.experience_details && (
                <>
                  <b>Experience Details</b><br /> {appointment.review.experience_details}<br /><br />
                </>
              )}
              {appointment.review.experience_rating && (
                <>
                  <b>Experience Rating</b><br /> {appointment.review.experience_rating}<br /><br />
                </>
              )}
              {appointment.review.receiver_name && (
                <>
                  <b>Receiver Name</b><br /> {appointment.review.receiver_name}<br /><br />
                </>
              )}
              {appointment.review.review && (
                <>
                  <b>Review</b><br /> {appointment.review.review}
                  <br />
                  <br />
                </>
              )}
              {appointment.review.technician_takeaways && (
                <>
                  <b>Technician Takeaways</b><br /> {appointment.review.technician_takeaways}
                  <br />
                  <br />
                </>
              )}
              {appointment.review.tip_receiv && (
                <>
                  <b>Tip Received</b><br /> {appointment.review.tip_received}
                  <br />
                  <br />
                </>
              )}
              {appointment.pictures && (
                <>
                  <b>Pictures</b><br />
                  {appointment.pictures.map((picture) => (
                    <Link to={picture.image_url} target="_blank">
                    <img width="400" src={picture.image_url} alt="Appointment" />
                    </Link>
                  ))}
                  <br />
                  <br />
                </>
              )}
            </>
          )}
        </center>
      )}

      {appointmentLoading && <Loading />}
      {appointmentError && <>{appointmentError} - Please contact Florent</>}
    </div>
  );
};

export default Appointment;
